var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('a-spin', {
    attrs: {
      "spinning": _vm.loading
    }
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('div', {
    staticClass: "d-flex justify-content-between align-items-center"
  }, [_c('h5', {
    staticClass: "mb-0"
  }, [_c('strong', [_vm._v("API Keys Management")])]), _c('a-button', {
    attrs: {
      "type": "primary",
      "icon": "plus"
    },
    on: {
      "click": _vm.showCreateModal
    }
  }, [_vm._v(" Create API Key ")])], 1)]), _c('div', {
    staticClass: "card-body"
  }, [_c('a-table', {
    attrs: {
      "columns": _vm.columns,
      "data-source": _vm.apiKeys,
      "pagination": {
        pageSize: 10
      },
      "scroll": {
        x: 1200
      },
      "row-key": function rowKey(record) {
        return record.id;
      }
    },
    scopedSlots: _vm._u([{
      key: "status",
      fn: function fn(text, record) {
        return [_c('a-tag', {
          attrs: {
            "color": _vm.getStatusColor(record)
          }
        }, [_vm._v(" " + _vm._s(_vm.getStatusText(record)) + " ")])];
      }
    }, {
      key: "validity",
      fn: function fn(text, record) {
        return [_c('div', [_c('div', [_c('strong', [_vm._v("From:")]), _vm._v(" " + _vm._s(_vm.formatDate(record.valid_from)) + " ")]), _c('div', [_c('strong', [_vm._v("To:")]), _vm._v(" " + _vm._s(_vm.formatDate(record.valid_to)) + " ")])])];
      }
    }, {
      key: "lastUsed",
      fn: function fn(text, record) {
        return [record.last_used_at ? _c('span', [_vm._v(" " + _vm._s(_vm.formatDate(record.last_used_at)) + " ")]) : _c('span', {
          staticClass: "text-muted"
        }, [_vm._v("Never used")])];
      }
    }, {
      key: "epexMember",
      fn: function fn(text, record) {
        return [record.epex_member ? _c('span', [_vm._v(" " + _vm._s(record.epex_member.epex_name) + " ")]) : _c('span', {
          staticClass: "text-muted"
        }, [_vm._v("No member assigned")])];
      }
    }, {
      key: "actions",
      fn: function fn(text, record) {
        return [_c('a-dropdown', [_c('a-menu', {
          attrs: {
            "slot": "overlay"
          },
          slot: "overlay"
        }, [record.is_active ? _c('a-menu-item', {
          key: "deactivate-".concat(record.id),
          on: {
            "click": function click($event) {
              return _vm.deactivateApiKey(record);
            }
          }
        }, [_c('a-icon', {
          attrs: {
            "type": "stop"
          }
        }), _vm._v(" Deactivate ")], 1) : _vm._e(), !record.is_active && !_vm.isExpired(record) ? _c('a-menu-item', {
          key: "reactivate-".concat(record.id),
          on: {
            "click": function click($event) {
              return _vm.reactivateApiKey(record);
            }
          }
        }, [_c('a-icon', {
          attrs: {
            "type": "play-circle"
          }
        }), _vm._v(" Reactivate ")], 1) : _vm._e(), record.is_active && !_vm.isExpired(record) ? _c('a-menu-item', {
          key: "generate-".concat(record.id),
          on: {
            "click": function click($event) {
              return _vm.generateNewToken(record);
            }
          }
        }, [_c('a-icon', {
          attrs: {
            "type": "key"
          }
        }), _vm._v(" Generate New Token ")], 1) : _vm._e(), _c('a-menu-item', {
          key: "edit-".concat(record.id),
          on: {
            "click": function click($event) {
              return _vm.editApiKey(record);
            }
          }
        }, [_c('a-icon', {
          attrs: {
            "type": "edit"
          }
        }), _vm._v(" Edit ")], 1), _c('a-menu-divider'), _c('a-menu-item', {
          key: "delete-".concat(record.id),
          staticClass: "text-danger",
          on: {
            "click": function click($event) {
              return _vm.confirmDelete(record);
            }
          }
        }, [_c('a-icon', {
          attrs: {
            "type": "delete"
          }
        }), _vm._v(" Delete ")], 1)], 1), _c('a-button', {
          attrs: {
            "size": "small"
          }
        }, [_vm._v(" Actions "), _c('a-icon', {
          attrs: {
            "type": "down"
          }
        })], 1)], 1)];
      }
    }])
  })], 1)])]), _c('a-modal', {
    attrs: {
      "title": _vm.isEditing ? 'Edit API Key' : 'Create New API Key',
      "visible": _vm.modalVisible,
      "confirm-loading": _vm.modalLoading,
      "width": 600
    },
    on: {
      "ok": _vm.handleModalOk,
      "cancel": _vm.handleModalCancel
    }
  }, [_c('a-form-model', {
    ref: "apiKeyForm",
    attrs: {
      "model": _vm.form,
      "rules": _vm.rules,
      "label-col": {
        span: 6
      },
      "wrapper-col": {
        span: 18
      }
    }
  }, [_c('a-form-model-item', {
    attrs: {
      "label": "Name",
      "prop": "name"
    }
  }, [_c('a-input', {
    attrs: {
      "placeholder": "Enter a descriptive name for this API key"
    },
    model: {
      value: _vm.form.name,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "name", $$v);
      },
      expression: "form.name"
    }
  })], 1), _c('a-form-model-item', {
    attrs: {
      "label": "Contact Full Name",
      "prop": "contact_full_name"
    }
  }, [_c('a-input', {
    attrs: {
      "placeholder": "Enter contact person's full name (optional)"
    },
    model: {
      value: _vm.form.contact_full_name,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "contact_full_name", $$v);
      },
      expression: "form.contact_full_name"
    }
  })], 1), _c('a-form-model-item', {
    attrs: {
      "label": "Contact Email",
      "prop": "contact_email"
    }
  }, [_c('a-input', {
    attrs: {
      "placeholder": "Enter contact person's email (optional)"
    },
    model: {
      value: _vm.form.contact_email,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "contact_email", $$v);
      },
      expression: "form.contact_email"
    }
  })], 1), _c('a-form-model-item', {
    attrs: {
      "label": "EPEX Member",
      "prop": "epex_member_id"
    }
  }, [_c('a-select', {
    attrs: {
      "placeholder": "Select EPEX Member (optional)",
      "allow-clear": "",
      "show-search": "",
      "filter-option": _vm.filterOption
    },
    model: {
      value: _vm.form.epex_member_id,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "epex_member_id", $$v);
      },
      expression: "form.epex_member_id"
    }
  }, _vm._l(_vm.epexMembers, function (member) {
    return _c('a-select-option', {
      key: member.id,
      attrs: {
        "value": member.id
      }
    }, [_vm._v(" " + _vm._s(member.epex_name) + " (" + _vm._s(member.eic_code) + ") ")]);
  }), 1)], 1), _c('a-form-model-item', {
    attrs: {
      "label": "Valid From",
      "prop": "valid_from"
    }
  }, [_c('a-date-picker', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "show-time": "",
      "format": "YYYY-MM-DD HH:mm:ss",
      "placeholder": "Select start date and time"
    },
    model: {
      value: _vm.form.valid_from,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "valid_from", $$v);
      },
      expression: "form.valid_from"
    }
  })], 1), _c('a-form-model-item', {
    attrs: {
      "label": "Valid To",
      "prop": "valid_to"
    }
  }, [_c('a-date-picker', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "show-time": "",
      "format": "YYYY-MM-DD HH:mm:ss",
      "placeholder": "Select end date and time"
    },
    model: {
      value: _vm.form.valid_to,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "valid_to", $$v);
      },
      expression: "form.valid_to"
    }
  })], 1), _c('a-form-model-item', {
    attrs: {
      "label": "Active",
      "prop": "is_active"
    }
  }, [_c('a-switch', {
    model: {
      value: _vm.form.is_active,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "is_active", $$v);
      },
      expression: "form.is_active"
    }
  }), _c('span', {
    staticClass: "ml-2 text-muted"
  }, [_vm._v(" " + _vm._s(_vm.form.is_active ? 'API key is active' : 'API key is inactive') + " ")])], 1)], 1)], 1), _c('a-modal', {
    attrs: {
      "title": "API Key Token Generated",
      "visible": _vm.tokenModalVisible,
      "footer": null,
      "width": 700
    },
    on: {
      "ok": function ok($event) {
        _vm.tokenModalVisible = false;
      },
      "cancel": function cancel($event) {
        _vm.tokenModalVisible = false;
      }
    }
  }, [_c('a-alert', {
    staticClass: "mb-3",
    attrs: {
      "message": "Important: Save this token securely",
      "description": "This JWT token will only be shown once. Make sure to copy and store it securely as you won't be able to see it again.",
      "type": "warning",
      "show-icon": ""
    }
  }), _c('div', {
    staticClass: "token-display"
  }, [_c('label', {
    staticClass: "font-weight-bold"
  }, [_vm._v("JWT Token:")]), _c('a-textarea', {
    staticClass: "mt-2",
    staticStyle: {
      "font-family": "monospace",
      "font-size": "12px"
    },
    attrs: {
      "value": _vm.generatedToken,
      "rows": 6,
      "readonly": ""
    }
  })], 1), _c('template', {
    slot: "footer"
  }, [_c('a-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.copyToken
    }
  }, [_vm._v(" Copy Token ")]), _c('a-button', {
    on: {
      "click": function click($event) {
        _vm.tokenModalVisible = false;
      }
    }
  }, [_vm._v(" Close ")])], 1)], 2)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }